var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraIcon = function SvgCameraIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.74 2.005c.17.019.328.102.439.235L11.645 4h1.688a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2.666a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1.688l1.467-1.76.05-.053A.67.67 0 0 1 6.333 2h3.333zM8 6a2.667 2.667 0 1 0 0 5.334A2.667 2.667 0 0 0 8 6"
  })));
};
export default SvgCameraIcon;